import {omneticApi} from '@dms/api/base';
import {
  AddFilesToVehicleAlbumApiArg,
  AddFilesToVehicleAlbumApiResponse,
  ArchiveVehicleApiArg,
  ArchiveVehicleApiResponse,
  BatchDownloadEventIdArg,
  BatchDownloadEventIdResponse,
  BulkCreateHighlightsApiArg,
  BulkCreateHighlightsApiResponse,
  BulkCreateShortcomingsApiArg,
  BulkCreateShortcomingsApiResponse,
  CreateVehicleApiArg,
  CreateVehicleApiResponse,
  CreateVehicleToBuyApiArg,
  CreateVehicleToBuyApiResponse,
  CreateVehicleV2ApiArg,
  CreateWatermarkV2ApiArg,
  CreateWatermarkV2ApiResponse,
  DeleteHighlightApiArg,
  DeleteHighlightApiResponse,
  DeleteShortcomingApiArg,
  DeleteShortcomingApiResponse,
  GetAdditionalNoteApiArg,
  GetAdditionalNoteApiResponse,
  GetSimilarVehiclesApiArg,
  GetSimilarVehiclesApiResponse,
  GetSimilarVehiclesV2ApiArg,
  GetSimilarVehiclesV2ApiResponse,
  GetVehicleApiArg,
  GetVehicleApiResponse,
  GetVehicleApiResponseV2,
  GetVehicleCoverPhotoApiArg,
  GetVehicleCoverPhotoApiResponse,
  GetVehicleFinancialInstitutionApiArg,
  GetVehicleFinancialInstitutionResponse,
  GetVehicleInsightsApiArg,
  GetVehicleInsightsApiRes,
  GetVehiclePhotosApiArg,
  GetVehiclePhotosApiRes,
  ListHighlightsApiArg,
  ListHighlightsApiResponse,
  ListShortcomingsApiArg,
  ListShortcomingsApiResponse,
  ListVehicleAlbumsApiArg,
  ListVehicleAlbumsApiResponse,
  PartialUpdateVehicleApiArg,
  PartialUpdateVehicleApiResponse,
  SetAdditionalNoteApiArg,
  SetAdditionalNoteApiResponse,
  UpdateVehicleApiArg,
  UpdateVehicleApiResponse,
  UpdateWatermarkV2ApiArg,
  UpdateVehicleFinancialInstitutionResponse,
  UpdateVehicleV2ApiArg,
  UpdateWatermarkV2ApiResponse,
  UpdateVehicleFinancialInstitutionApiArg,
} from '@dms/api/shared';

import {isDefined} from 'shared/web';

import {
  AddFilesToServiceAlbumApiArg,
  AddFilesToServiceAlbumApiResponse,
  ChangeVehicleTypeApiArg,
  ChangeVehicleTypeApiResponse,
  CopyAuditPhotoToAlbumApiArg,
  CopyAuditPhotoToAlbumApiResponse,
  CreateBackgroundRemovalApiArg,
  CreateBackgroundRemovalApiResponse,
  CreatePriceReportRequestApiArg,
  CreatePriceReportRequestApiResponse,
  CreateVehicleAlbumApiArg,
  CreateVehicleAlbumApiResponse,
  CreateVehiclePriceReportApiArg,
  CreateVehiclePriceReportApiResponse,
  CreateVehiclePriceReportPreviewApiArg,
  CreateVehiclePriceReportPreviewApiResponse,
  CreateWatermarkApiArg,
  CreateWatermarkApiResponse,
  DeleteBackgroundRemovalApiArg,
  DeleteBackgroundRemovalApiResponse,
  DeletePhotoApiArg,
  DeletePhotoApiResponse,
  DeleteServicePhotoApiArg,
  DeleteServicePhotoApiResponse,
  DeleteVehicleAlbumApiArg,
  DeleteVehicleAlbumApiResponse,
  DeleteVehicleApiArg,
  DeleteVehicleApiResponse,
  DeleteWatermarkApiArg,
  DeleteWatermarkApiResponse,
  GetVehicleListApiArg,
  GetVehicleListApiResponse,
  DownloadServiceGalleryApiArg,
  DownloadServiceGalleryApiResponse,
  GetAuditsApiArg,
  GetAuditsApiResponse,
  GetAutofillFeaturesApiArg,
  GetAutofillFeaturesApiResponse,
  GetBackgroundRemovalListApiResponse,
  GetBackgroundRemovalV2ApiArg,
  GetBackgroundRemovalV2ApiResponse,
  GetServiceAlbumListApiArg,
  GetServiceAlbumListApiResponse,
  GetServiceAlbumPhotoListApiArg,
  GetServiceAlbumPhotoListApiResponse,
  GetVehicleAlbumPhotosApiArg,
  GetVehicleAlbumPhotosApiResponse,
  GetVehicleAlbumPhotoListApiArg,
  GetVehicleAlbumPhotoListApiResponse,
  SetVehicleAlbumCoverPhotoApiArg,
  SetVehicleAlbumCoverPhotoApiResponse,
  UnsetVehicleAlbumCoverPhotoApiArg,
  UnsetVehicleAlbumCoverPhotoApiResponse,
  GetVehicleHomeServiceArg,
  GetVehicleHomeServiceResponse,
  GetVehicleInsuranceApiArg,
  GetVehicleInsuranceApiResponse,
  GetVehiclePriceReportsApiArg,
  GetVehiclePriceReportsApiResponse,
  GetVehicleStatisticsApiArg,
  GetVehicleStatisticsApiResponse,
  GetWatermarkDetailApiArg,
  GetWatermarkDetailApiResponse,
  GetWatermarkListApiResponse,
  ListHighlightsForTenantApiArg,
  ListHighlightsForTenantApiResponse,
  ListShortcomingsForTenantApiArg,
  ListShortcomingsForTenantApiResponse,
  ListTestDriveApiArgVehicle,
  ListTestDriveApiResponseVehicle,
  PutAutofillFeaturesApiArg,
  PutAutofillFeaturesApiResponse,
  PutBackgroundRemovalSettingsApiArg,
  PutBackgroundRemovalSettingsApiResponse,
  PutVehicleHomeServiceArg,
  PutVehicleHomeServiceResponse,
  PutVehicleToSaleApiResponse,
  PutVehicleToSaleArg,
  RemoveVehiclePhotosBackgroundApiArg,
  RemoveVehiclePhotosBackgroundApiResponse,
  RotateVehiclePhotoApiArg,
  RotateVehiclePhotoApiRes,
  SetFeatureAsHighlightedApiArg,
  SetFeatureAsHighlightedApiResponse,
  SetFeaturesHighlightedApiArg,
  SetFeaturesHighlightedApiRes,
  SetVehicleCustomIdApiArg,
  SetVehicleCustomIdApiResponse,
  SetVehicleInsuranceApiArg,
  UpdateBackgroundRemovalV2ApiArg,
  UpdateBackgroundRemovalV2ApiResponse,
  UpdateWatermarkDetailApiArg,
  UpdateWatermarkDetailApiResponse,
  VehiclePhotoCopyApiResponse,
  VehiclePhotoCopyApiArg,
  VehiclePhotoUpdateAlbumApiResponse,
  VehiclePhotoUpdateAlbumApiArg,
  ApiVehiclePhotoDeleteApiResponse,
  ApiVehiclePhotoDeleteApiArg,
  GetVehicleMileageValidationApiResponse,
  GetVehicleMileageValidationApiArg,
  GetVehicleMileageApiResponse,
  GetVehicleMileageApiArg,
  WriteVehicleMileageApiResponse,
  WriteVehicleMileageApiArg,
  CorrectVehicleMileageApiResponse,
  CorrectVehicleMileageApiArg,
  CreateAutotracerPlReportApiArg,
  CreateAutotracerPlReportApiResponse,
  GetVehicleAutotracerPlReportsApiArg,
  GetVehicleAutotracerPlReportsApiResponse,
  GetAutotracerPlReportApiArg,
  GetAutotracerPlReportApiResponse,
  GetAutotracerPlPreviewApiArg,
  GetAutotracerPlPreviewApiResponse,
} from './types';

export const vehicleApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getVehicle: build.query<GetVehicleApiResponse, GetVehicleApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}`,
      }),
      providesTags: (_result, _error, queryArg) => [{type: 'Vehicle', id: queryArg.vehicleId}],
    }),
    /**
     * @deprecated Use `@dms/api/modules/vehicleOperations getVehicle` instead
     */
    getVehicleV2: build.query<GetVehicleApiResponseV2, GetVehicleApiArg>({
      query: (queryArg) => ({
        url: `/dms/v2/vehicle/${queryArg.vehicleId}`,
      }),
      providesTags: (_result, _error, queryArg) => [{type: 'Vehicle', id: queryArg.vehicleId}],
    }),
    /**
     * @deprecated Use `@dms/api/modules/vehicleOperations createVehicle` instead
     */
    createVehicleV2: build.mutation<GetVehicleApiResponseV2, CreateVehicleV2ApiArg>({
      query: (body) => ({
        url: `/dms/v2/vehicle`,
        method: 'POST',
        body,
        params: {validateMandatoryFields: body.validateMandatoryFields},
      }),
    }),
    /**
     * @deprecated Use `@dms/api/modules/vehicleOperations updateVehicle` instead
     */
    updateVehicleV2: build.mutation<GetVehicleApiResponseV2, UpdateVehicleV2ApiArg>({
      query: ({id, ...body}) => ({
        url: `/dms/v2/vehicle/${id}`,
        method: 'PUT',
        body,
        params: {validateMandatoryFields: body.validateMandatoryFields},
      }),
      invalidatesTags: (_result, _error, queryArg) => [{type: 'Vehicle', id: queryArg.id}],
    }),
    getSimilarVehicles: build.query<GetSimilarVehiclesApiResponse, GetSimilarVehiclesApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/similar`,
        params: {
          size: queryArg.size,
          offset: queryArg.offset,
          vin: queryArg.vin,
          vinContains: queryArg.vinContains,
          registrationPlateContains: queryArg.registrationPlateContains,
        },
      }),
    }),
    getSimilarVehiclesV2: build.query<GetSimilarVehiclesV2ApiResponse, GetSimilarVehiclesV2ApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/similar-vehicle`,
        params: {
          size: queryArg.size,
          offset: queryArg.offset,
          vin: queryArg.vin,
          registrationPlateContains: queryArg.registrationPlateContains,
          vinContains: queryArg.vinContains,
        },
      }),
    }),
    deleteVehicle: build.mutation<DeleteVehicleApiResponse, DeleteVehicleApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, queryArg) => [{type: 'Vehicle', id: queryArg.vehicleId}],
    }),
    createVehiclePriceReport: build.mutation<
      CreateVehiclePriceReportApiResponse,
      CreateVehiclePriceReportApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v2/vehicle/${queryArg.vehicleId}/price-report`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['vehiclePriceReport'],
    }),
    getVehiclePriceReports: build.query<
      GetVehiclePriceReportsApiResponse,
      GetVehiclePriceReportsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v2/vehicle/${queryArg.vehicleId}/price-report`,
      }),
      providesTags: ['vehiclePriceReport'],
    }),
    createAutotracerPlReport: build.mutation<
      CreateAutotracerPlReportApiResponse,
      CreateAutotracerPlReportApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/autotracer-pl-report`,
        method: 'POST',
      }),
      invalidatesTags: ['AutotracerPlReport'],
    }),
    getVehicleAutotracerPlReports: build.query<
      GetVehicleAutotracerPlReportsApiResponse,
      GetVehicleAutotracerPlReportsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/autotracer-pl-report`,
      }),
      providesTags: ['AutotracerPlReport'],
    }),
    getAutotracerPlReport: build.query<
      GetAutotracerPlReportApiResponse,
      GetAutotracerPlReportApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/autotracer-pl-report/${queryArg.reportId}`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'AutotracerPlReport', id: queryArg.reportId},
      ],
    }),
    getAutotracerPlPreview: build.query<
      GetAutotracerPlPreviewApiResponse,
      GetAutotracerPlPreviewApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/autotracer-pl-preview`,
      }),
    }),
    listTestDrive: build.query<ListTestDriveApiResponseVehicle, ListTestDriveApiArgVehicle>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/test-drive`,
      }),
      providesTags: ['VehicleTestDrivesV1'],
    }),
    listShortcomings: build.query<ListShortcomingsApiResponse, ListShortcomingsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/shortcoming`,
      }),
      providesTags: (_result, _error, queryArg) => [{type: 'shortcomings', id: queryArg.vehicleId}],
    }),
    bulkCreateShortcomings: build.mutation<
      BulkCreateShortcomingsApiResponse,
      BulkCreateShortcomingsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/shortcoming/_bulk`,
        method: 'PUT',
        body: queryArg.shortcomingBulkRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'shortcomings', id: queryArg.vehicleId},
      ],
    }),
    deleteShortcoming: build.mutation<DeleteShortcomingApiResponse, DeleteShortcomingApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/shortcoming/${queryArg.shortcomingId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'shortcomings', id: queryArg.vehicleId},
      ],
    }),
    listHighlights: build.query<ListHighlightsApiResponse, ListHighlightsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/highlight`,
      }),
      providesTags: (_result, _error, queryArg) => [{type: 'highlights', id: queryArg.vehicleId}],
    }),
    bulkCreateHighlights: build.mutation<
      BulkCreateHighlightsApiResponse,
      BulkCreateHighlightsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/highlight/_bulk`,
        method: 'PUT',
        body: queryArg.highlightBulkRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'highlights', id: queryArg.vehicleId},
      ],
    }),
    deleteHighlight: build.mutation<DeleteHighlightApiResponse, DeleteHighlightApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/highlight/${queryArg.highlightId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'highlights', id: queryArg.vehicleId},
      ],
    }),

    getVehiclePhotos: build.query<GetVehiclePhotosApiRes, GetVehiclePhotosApiArg>({
      keepUnusedDataFor: 0,
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/photo`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'VehiclePhotos', id: queryArg.vehicleId},
      ],
    }),
    getVehicleCoverPhoto: build.query<GetVehicleCoverPhotoApiResponse, GetVehicleCoverPhotoApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/cover-photo`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'VehicleCoverPhoto', id: queryArg.vehicleId},
      ],
    }),
    getVehicleAlbumPhotos: build.query<
      GetVehicleAlbumPhotosApiResponse,
      GetVehicleAlbumPhotosApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/album/${queryArg.vehicleAlbumId}/photo`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'VehicleAlbumPhotos', id: queryArg.vehicleAlbumId},
      ],
    }),
    getVehicleAlbumPhotoList: build.query<
      GetVehicleAlbumPhotoListApiResponse,
      GetVehicleAlbumPhotoListApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v2/vehicle/${queryArg.vehicleId}/vehicle-album/${queryArg.vehicleAlbumId}/vehicle-photo`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'VehicleAlbumPhotos', id: queryArg.vehicleAlbumId},
      ],
    }),
    setVehicleAlbumCoverPhoto: build.mutation<
      SetVehicleAlbumCoverPhotoApiResponse,
      SetVehicleAlbumCoverPhotoApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/vehicle-album/${queryArg.vehicleAlbumId}/cover-photo/${queryArg.vehiclePhotoId}`,
        method: 'PUT',
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'VehicleAlbumPhotos', id: queryArg.vehicleAlbumId},
        {type: 'VehicleCoverPhoto', id: queryArg.vehicleId},
        {type: 'VehiclePhotos', id: queryArg.vehicleId},
        {type: 'Vehicle', id: queryArg.vehicleId},
      ],
    }),
    unsetVehicleAlbumCoverPhoto: build.mutation<
      UnsetVehicleAlbumCoverPhotoApiResponse,
      UnsetVehicleAlbumCoverPhotoApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/vehicle-album/${queryArg.vehicleAlbumId}/cover-photo`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'VehicleAlbumPhotos', id: queryArg.vehicleAlbumId},
        {type: 'VehicleCoverPhoto', id: queryArg.vehicleId},
        {type: 'VehiclePhotos', id: queryArg.vehicleId},
        {type: 'Vehicle', id: queryArg.vehicleId},
      ],
    }),

    downloadGallery: build.query<BatchDownloadEventIdResponse, BatchDownloadEventIdArg>({
      keepUnusedDataFor: 0,
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/download-gallery/${queryArg.vehiclePhotoLocation}`,
        method: 'POST',
        params: {
          auditId: queryArg.auditId,
          albumId: queryArg.albumId,
        },
      }),
    }),
    getVehicleInsights: build.query<GetVehicleInsightsApiRes, GetVehicleInsightsApiArg>({
      keepUnusedDataFor: 0,
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/insights`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'VehicleInsights', id: queryArg.vehicleId},
      ],
    }),
    getVehicleStatistics: build.query<GetVehicleStatisticsApiResponse, GetVehicleStatisticsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/statistics/vehicle/`,
        params: {branchId: queryArg.branchId},
      }),
      providesTags: ['SaleVehicle'],
    }),
    partialUpdateVehicle: build.mutation<
      PartialUpdateVehicleApiResponse,
      PartialUpdateVehicleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}`,
        method: 'PATCH',
        body: queryArg.patchVehicleRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [{type: 'Vehicle', id: queryArg.vehicleId}],
    }),
    createVehicle: build.mutation<CreateVehicleApiResponse, CreateVehicleApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle`,
        method: 'POST',
        body: queryArg.vehicleRequestBody,
        params: {validateMandatoryFields: queryArg.validateMandatoryFields},
      }),
      invalidatesTags: [
        'AdGeneralSettings',
        'AdPlatformSettings',
        'AdWindshieldSettings',
        'SimilarVehiclesCount',
        'CustomTenantCatalogue',
      ],
    }),
    createVehicleToBuy: build.mutation<CreateVehicleToBuyApiResponse, CreateVehicleToBuyApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/to-buy`,
        method: 'POST',
        body: queryArg.vehicleRequestBody,
        params: {validateMandatoryFields: queryArg.validateMandatoryFields},
      }),
      invalidatesTags: [
        'AdGeneralSettings',
        'AdPlatformSettings',
        'AdWindshieldSettings',
        'SimilarVehiclesCount',
      ],
    }),
    updateVehicle: build.mutation<UpdateVehicleApiResponse, UpdateVehicleApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}`,
        method: 'PUT',
        body: queryArg.vehicleRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'Vehicle', id: queryArg.vehicleId},
        {type: 'SimilarVehiclesCount', id: queryArg.vehicleId},
        'AdGeneralSettings',
        'AdPlatformSettings',
        'AdWindshieldSettings',
        'CustomTenantCatalogue',
      ],
    }),
    getAdditionalNote: build.query<GetAdditionalNoteApiResponse, GetAdditionalNoteApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/additional-note`,
      }),
      providesTags: (_result, _error, queryArg) => [{type: 'VehicleNote', id: queryArg.vehicleId}],
    }),
    setAdditionalNote: build.mutation<SetAdditionalNoteApiResponse, SetAdditionalNoteApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/additional-note`,
        method: 'PUT',
        body: queryArg.additionalNoteRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'VehicleNote', id: queryArg.vehicleId},
      ],
    }),
    getAutofillFeatures: build.query<GetAutofillFeaturesApiResponse, GetAutofillFeaturesApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/autofill-features/${queryArg.vin}`,
        params: {decoderType: queryArg.decoderType},
      }),
    }),
    putAutofillFeatures: build.query<PutAutofillFeaturesApiResponse, PutAutofillFeaturesApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/autofill-features/${queryArg.vehicleId}`,
        method: 'PUT',
      }),
    }),
    getVehicleList: build.query<GetVehicleListApiResponse, GetVehicleListApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle`,
        params: {
          size: queryArg.size,
          offset: queryArg.offset,
          customerId: queryArg.customerId,
          vin: queryArg.vin,
          registerNumber: queryArg.registerNumber,
          publicId: queryArg.publicId,
          externalId: queryArg.externalId,
        },
      }),
    }),
    getVehicleFinancialInstitution: build.query<
      GetVehicleFinancialInstitutionResponse,
      GetVehicleFinancialInstitutionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/financial-institution`,
        method: 'GET',
      }),
      providesTags: (result) => [{type: 'VehicleFinancialInstitution', id: result?.vehicleId}],
    }),
    updateVehicleFinancialInstitution: build.mutation<
      UpdateVehicleFinancialInstitutionResponse,
      UpdateVehicleFinancialInstitutionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/financial-institution`,
        method: 'PUT',
        body: queryArg.body,
      }),
      invalidatesTags: (result) => [{type: 'VehicleFinancialInstitution', id: result?.vehicleId}],
    }),
    archiveVehicle: build.mutation<ArchiveVehicleApiResponse, ArchiveVehicleApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/archive`,
        method: 'PATCH',
      }),
      invalidatesTags: (_result, _error, queryArg) => [{type: 'Vehicle', id: queryArg.vehicleId}],
    }),
    unarchiveVehicle: build.mutation<ArchiveVehicleApiResponse, ArchiveVehicleApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/unarchive`,
        method: 'PATCH',
      }),
      invalidatesTags: (_result, _error, queryArg) => [{type: 'Vehicle', id: queryArg.vehicleId}],
    }),
    listVehicleAlbums: build.query<ListVehicleAlbumsApiResponse, ListVehicleAlbumsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/vehicle-album`,
        params: {vehicleId: queryArg.vehicleId, serviceCaseId: queryArg.serviceCaseId},
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'VehicleAlbumList', id: queryArg.vehicleId ?? queryArg.serviceCaseId ?? 'LIST'},
      ],
    }),
    createVehicleAlbum: build.mutation<CreateVehicleAlbumApiResponse, CreateVehicleAlbumApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/vehicle-album`,
        method: 'POST',
        body: queryArg.createVehicleAlbumRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        'Vehicle',
        'VehiclePhotos',
        {
          type: 'VehicleAlbumList',
          id:
            queryArg.createVehicleAlbumRequestBody.vehicleId ??
            queryArg.createVehicleAlbumRequestBody.serviceCaseId ??
            'LIST',
        },
      ],
    }),
    addFilesToVehicleAlbum: build.mutation<
      AddFilesToVehicleAlbumApiResponse,
      AddFilesToVehicleAlbumApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/vehicle-album/${queryArg.vehicleAlbumId}`,
        method: 'POST',
        body: queryArg.addFilesToVehicleAlbumRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) =>
        [
          {type: 'Vehicle' as const, id: queryArg.vehicleId},
          {type: 'VehiclePhotos' as const, id: queryArg.vehicleId},
          {type: 'VehicleAlbumPhotos' as const, id: queryArg.vehicleAlbumId},
          {type: 'VehicleCoverPhoto' as const, id: queryArg.vehicleId},
          {type: 'SaleVehicle' as const, id: queryArg.vehicleId},
          {type: 'SaleVehicleActions' as const, id: queryArg.vehicleId},
        ] as const,
    }),
    deleteVehicleAlbum: build.mutation<DeleteVehicleAlbumApiResponse, DeleteVehicleAlbumApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/vehicle-album/${queryArg.vehicleAlbumId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{type: 'VehicleAlbumList'}],
    }),
    deletePhoto: build.mutation<DeletePhotoApiResponse, DeletePhotoApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/photo/${queryArg.vehicleId}/${queryArg.albumId}`,
        method: 'DELETE',
        body: queryArg.vehiclePhotoDeleteRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'Vehicle', id: queryArg.vehicleId},
        {type: 'VehiclePhotos', id: queryArg.vehicleId},
        {type: 'VehicleAlbumPhotos', id: queryArg.albumId},
        {type: 'VehicleCoverPhoto', id: queryArg.vehicleId},
        {type: 'SaleVehicle', id: queryArg.vehicleId},
        {type: 'SaleVehicleActions', id: queryArg.vehicleId},
      ],
    }),
    removeVehiclePhotosBackground: build.mutation<
      RemoveVehiclePhotosBackgroundApiResponse,
      RemoveVehiclePhotosBackgroundApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/remove-photo-background`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'VehiclePhotos', id: queryArg.vehicleId},
      ],
    }),
    setFeaturesHighlighted: build.mutation<
      SetFeaturesHighlightedApiRes,
      SetFeaturesHighlightedApiArg
    >({
      query: ({vehicleId, ...body}) => ({
        url: `/dms/v1/vehicle/${vehicleId}/features/_bulk`,
        method: 'PUT',
        body,
      }),
    }),
    setFeatureAsHighlighted: build.mutation<
      SetFeatureAsHighlightedApiResponse,
      SetFeatureAsHighlightedApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/feature/${queryArg.featureKey}`,
        method: 'PUT',
      }),
      async onQueryStarted({vehicleId, featureKey}, {dispatch, queryFulfilled}) {
        const patchResult = dispatch(
          vehicleApi.util.updateQueryData('getVehicleV2', {vehicleId}, (draft) => {
            const features = draft.features?.map((item) => {
              if (item.key !== featureKey) {
                return item;
              }
              return {...item, isHighlighted: true};
            });

            return {
              ...draft,
              features,
            };
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
    setFeatureAsNotHighlighted: build.mutation<
      SetFeatureAsHighlightedApiResponse,
      SetFeatureAsHighlightedApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/feature/${queryArg.featureKey}`,
        method: 'DELETE',
      }),
      async onQueryStarted({vehicleId, featureKey}, {dispatch, queryFulfilled}) {
        const patchResult = dispatch(
          vehicleApi.util.updateQueryData('getVehicleV2', {vehicleId}, (draft) => {
            const features = draft.features?.map((item) => {
              if (item.key !== featureKey) {
                return item;
              }

              return {...item, isHighlighted: false};
            });

            return {
              ...draft,
              features,
            };
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
    rotateVehiclePhoto: build.mutation<RotateVehiclePhotoApiRes, RotateVehiclePhotoApiArg>({
      query: ({vehicleAlbumId, vehicleId, ...body}) => ({
        url: `/dms/v1/vehicle/${vehicleId}/album/${vehicleAlbumId}/rotate-photo`,
        body,
        method: 'POST',
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'VehiclePhotos', id: queryArg.vehicleId},
      ],
      transformResponse(_response, _meta, arg) {
        return {vehiclePhotoIds: arg.vehiclePhotoIds};
      },
    }),
    getBackgroundRemovalList: build.query<GetBackgroundRemovalListApiResponse, void>({
      query: () => ({
        url: `/dms/v1/settings/background-removal/list`,
      }),
      providesTags: ['backgroundRemovalSettings'],
    }),
    putBackgroundRemovalSettings: build.mutation<
      PutBackgroundRemovalSettingsApiResponse,
      PutBackgroundRemovalSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/settings/background-removal`,
        method: 'PUT',
        body: queryArg.body,
      }),
      invalidatesTags: ['backgroundRemovalSettings'],
    }),
    createPriceReportRequest: build.mutation<
      CreatePriceReportRequestApiResponse,
      CreatePriceReportRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/price-report-request`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['vehiclePriceReport'],
    }),
    createVehiclePriceReportPreview: build.query<
      CreateVehiclePriceReportPreviewApiResponse,
      CreateVehiclePriceReportPreviewApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/price-report-preview`,
        method: 'POST',
        body: queryArg.createVehiclePriceReportRequestBody,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'SimilarVehiclesCount', id: queryArg.vehicleId},
      ],
    }),
    getVehicleInsurance: build.query<GetVehicleInsuranceApiResponse, GetVehicleInsuranceApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/insurance`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'vehicleInsurance', id: queryArg.vehicleId},
      ],
    }),
    setVehicleInsurance: build.mutation<void, SetVehicleInsuranceApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/insurance`,
        method: 'PUT',
        body: queryArg.data,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'vehicleInsurance', id: queryArg.vehicleId},
      ],
    }),
    getAudits: build.query<GetAuditsApiResponse, GetAuditsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/audit`,
      }),
    }),
    setVehicleCustomId: build.mutation<SetVehicleCustomIdApiResponse, SetVehicleCustomIdApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/custom-id`,
        method: 'PUT',
        body: queryArg.setVehicleCustomIdRequestBody,
      }),
      invalidatesTags: (result, error, queryArg) => [{type: 'Vehicle', id: queryArg.vehicleId}],
    }),
    copyAuditPhotoToAlbum: build.mutation<
      CopyAuditPhotoToAlbumApiResponse,
      CopyAuditPhotoToAlbumApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/copy-audit-photo`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (_result, _error) => [
        {type: 'SaleVehicleAlbumPhotos'},
        {type: 'VehiclePhotos'},
        {type: 'Vehicle'},
      ],
    }),
    getServiceVehicleHomeBranch: build.query<
      GetVehicleHomeServiceResponse,
      GetVehicleHomeServiceArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/home-service`,
      }),
      providesTags: (_response, _error, args) => [
        {type: 'ServiceVehicleHomeService', id: args.vehicleId},
      ],
    }),
    putServiceVehicleHomeBranch: build.mutation<
      PutVehicleHomeServiceResponse,
      PutVehicleHomeServiceArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/home-service`,
        method: 'PUT',
        body: queryArg.body,
      }),
      invalidatesTags: (_response, error, args) =>
        isDefined(error)
          ? []
          : [{type: 'ServiceVehicleHomeService', id: args.vehicleId}, 'participation'],
    }),
    changeVehicleType: build.mutation<ChangeVehicleTypeApiResponse, ChangeVehicleTypeApiArg>({
      query: ({vehicleId, ...body}) => ({
        url: `/dms/v1/vehicle/${vehicleId}/vehicle-type`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_response, _error, args) => [
        {type: 'Vehicle', id: args.vehicleId},
        'AdGeneralSettings',
        'AdPlatformSettings',
        'AdWindshieldSettings',
      ],
    }),
    createBackgroundRemoval: build.mutation<
      CreateBackgroundRemovalApiResponse,
      CreateBackgroundRemovalApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/settings/background-removal`,
        method: 'POST',
        body: queryArg.createBackgroundRemovalRequestBody,
      }),
    }),
    getBackgroundRemovalV2: build.query<
      GetBackgroundRemovalV2ApiResponse,
      GetBackgroundRemovalV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v2/settings/background-removal/${queryArg.settingId}`,
      }),
    }),
    updateBackgroundRemovalV2: build.mutation<
      UpdateBackgroundRemovalV2ApiResponse,
      UpdateBackgroundRemovalV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v2/settings/background-removal/${queryArg.settingId}`,
        method: 'PUT',
        body: queryArg.updateBackgroundRemovalRequestBody,
      }),
      invalidatesTags: ['backgroundRemovalSettings'],
    }),
    deleteBackgroundRemoval: build.mutation<
      DeleteBackgroundRemovalApiResponse,
      DeleteBackgroundRemovalApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/settings/background-removal/${queryArg.settingId}`,
        method: 'DELETE',
      }),
    }),
    createWatermark: build.mutation<CreateWatermarkApiResponse, CreateWatermarkApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/settings/watermark`,
        method: 'POST',
        body: queryArg.createWatermarkRequestBody,
      }),
      invalidatesTags: (_response, _error, _args) => ['WatermarkDetial', 'WatermarkList'],
    }),
    createWatermarkV2: build.mutation<CreateWatermarkV2ApiResponse, CreateWatermarkV2ApiArg>({
      query: (queryArg) => ({
        url: `/dms/v2/settings/watermark`,
        method: 'POST',
        body: queryArg.createWatermarkV2RequestBody,
      }),
      invalidatesTags: (_response, _error, _args) => ['WatermarkDetial', 'WatermarkList'],
    }),
    updateWatermarkV2: build.mutation<UpdateWatermarkV2ApiResponse, UpdateWatermarkV2ApiArg>({
      query: (queryArg) => ({
        url: `/dms/v2/settings/watermark/${queryArg.watermarkId}`,
        method: 'PUT',
        body: queryArg.updateWatermarkV2RequestBody,
      }),
      invalidatesTags: (_response, _error, args) => [
        {type: 'WatermarkDetial', id: args.watermarkId},
        'WatermarkList',
      ],
    }),
    deleteWatermark: build.mutation<DeleteWatermarkApiResponse, DeleteWatermarkApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/settings/watermark/${queryArg.watermarkId}`,
        method: 'DELETE',
        body: queryArg.deleteWatermarkRequestBody,
      }),
      invalidatesTags: (_response, _error, args) => [
        {type: 'WatermarkDetial', id: args.watermarkId},
        'WatermarkList',
      ],
    }),
    getWatermarkDetail: build.query<GetWatermarkDetailApiResponse, GetWatermarkDetailApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/settings/watermark/${queryArg.watermarkId}`,
      }),
      providesTags: (_response, _error, args) => [{type: 'WatermarkDetial', id: args.watermarkId}],
    }),
    updateWatermarkDetail: build.mutation<
      UpdateWatermarkDetailApiResponse,
      UpdateWatermarkDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/settings/watermark/${queryArg.watermarkId}`,
        method: 'PUT',
        body: queryArg.updateWatermarkRequestBody,
      }),
      invalidatesTags: (_response, _error, args) => [
        {type: 'WatermarkDetial', id: args.watermarkId},
        'WatermarkList',
      ],
    }),
    getWatermarkList: build.query<GetWatermarkListApiResponse, void>({
      query: () => ({
        url: `/dms/v1/settings/watermark`,
      }),
      providesTags: () => ['WatermarkList'],
    }),
    getServiceAlbumList: build.query<GetServiceAlbumListApiResponse, GetServiceAlbumListApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/service-album`,
        params: {serviceCaseId: queryArg.serviceCaseId},
      }),
    }),
    getServiceAlbumPhotoList: build.query<
      GetServiceAlbumPhotoListApiResponse,
      GetServiceAlbumPhotoListApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/service-album/${queryArg.serviceAlbumId}/service-photo`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'ServiceAlbumPhotoList', id: queryArg.serviceAlbumId},
      ],
    }),
    downloadServiceGallery: build.mutation<
      DownloadServiceGalleryApiResponse,
      DownloadServiceGalleryApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/service-album/${queryArg.serviceAlbumId}/download`,
        method: 'POST',
      }),
    }),
    addFilesToServiceAlbum: build.mutation<
      AddFilesToServiceAlbumApiResponse,
      AddFilesToServiceAlbumApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/service-album/${queryArg.serviceAlbumId}/photo`,
        method: 'POST',
        body: queryArg.addFilesToServiceAlbumRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'Vehicle', id: queryArg.vehicleId},
        {type: 'SaleVehicle', id: queryArg.vehicleId},
        {type: 'SaleVehicleActions', id: queryArg.vehicleId},
        {type: 'ServiceAlbumPhotoList', id: queryArg.serviceAlbumId},
      ],
    }),
    deleteServicePhoto: build.mutation<DeleteServicePhotoApiResponse, DeleteServicePhotoApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/service-album/${queryArg.serviceAlbumId}/photo/${queryArg.servicePhotoId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'Vehicle', id: queryArg.vehicleId},
        {type: 'ServiceAlbumPhotoList', id: queryArg.serviceAlbumId},
      ],
    }),
    putVehicleToSale: build.mutation<PutVehicleToSaleApiResponse, PutVehicleToSaleArg>({
      query: ({vehicleId}) => ({
        url: `/dms/v1/vehicle/${vehicleId}/register-for-sale`,
        method: 'PUT',
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'Vehicle', id: queryArg.vehicleId},
        {type: 'SaleVehicle', id: queryArg.vehicleId},
        {type: 'SaleVehicleActions', id: queryArg.vehicleId},
        'AdGeneralSettings',
        'AdPlatformSettings',
        'AdWindshieldSettings',
      ],
    }),
    listHighlightsForTenant: build.query<
      ListHighlightsForTenantApiResponse,
      ListHighlightsForTenantApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/highlight/tenant/list`,
        params: {size: queryArg.size, offset: queryArg.offset},
      }),
    }),
    listShortcomingsForTenant: build.query<
      ListShortcomingsForTenantApiResponse,
      ListShortcomingsForTenantApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/shortcoming/tenant/list`,
        params: {size: queryArg.size, offset: queryArg.offset},
      }),
    }),
    vehiclePhotoCopy: build.mutation<VehiclePhotoCopyApiResponse, VehiclePhotoCopyApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/photo/copy/${queryArg.vehicleId}`,
        method: 'PUT',
        body: queryArg.vehiclePhotoCopyRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'Vehicle', id: queryArg.vehicleId},
        {type: 'VehiclePhotos', id: queryArg.vehicleId},
        {
          type: 'VehicleAlbumPhotos',
          id: queryArg.vehiclePhotoCopyRequestBody.sourceAlbum,
        },
        {
          type: 'VehicleAlbumPhotos',
          id: queryArg.vehiclePhotoCopyRequestBody.destinationAlbum,
        },
        {type: 'SaleVehicle', id: queryArg.vehicleId},
        {type: 'SaleVehicleActions', id: queryArg.vehicleId},
      ],
    }),
    vehiclePhotoDelete: build.mutation<
      ApiVehiclePhotoDeleteApiResponse,
      ApiVehiclePhotoDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/photo/${queryArg.vehicleId}/${queryArg.albumId}`,
        method: 'DELETE',
        body: queryArg.vehiclePhotoDeleteRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'Vehicle' as const, id: queryArg.vehicleId},
        {type: 'VehiclePhotos' as const, id: queryArg.vehicleId},
        {type: 'VehicleAlbumPhotos' as const, id: queryArg.albumId},
        {type: 'SaleVehicle' as const, id: queryArg.vehicleId},
        {type: 'SaleVehicleActions' as const, id: queryArg.vehicleId},
      ],
    }),
    vehiclePhotoUpdateAlbum: build.mutation<
      VehiclePhotoUpdateAlbumApiResponse,
      VehiclePhotoUpdateAlbumApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/photo/${queryArg.vehicleId}`,
        method: 'PUT',
        body: queryArg.vehiclePhotoUpdateAlbumRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'Vehicle', id: queryArg.vehicleId},
        {type: 'VehiclePhotos', id: queryArg.vehicleId},
        {
          type: 'VehicleAlbumPhotos',
          id: queryArg.vehiclePhotoUpdateAlbumRequestBody.sourceAlbum,
        },
        {
          type: 'VehicleAlbumPhotos',
          id: queryArg.vehiclePhotoUpdateAlbumRequestBody.destinationAlbum,
        },
        {type: 'SaleVehicle', id: queryArg.vehicleId},
        {type: 'SaleVehicleActions', id: queryArg.vehicleId},
      ],
    }),
    getVehicleMileageValidation: build.query<
      GetVehicleMileageValidationApiResponse,
      GetVehicleMileageValidationApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle-mileage`,
        params: {
          vehicleId: queryArg.vehicleId,
          mileage: queryArg.mileage,
        },
      }),
      providesTags: (_result, _error, queryArg) => [{type: 'Vehicle', id: queryArg.vehicleId}],
    }),
    getVehicleMileage: build.query<GetVehicleMileageApiResponse, GetVehicleMileageApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/mileage`,
      }),
      providesTags: (_result, _error, queryArg) => [{type: 'Vehicle', id: queryArg.vehicleId}],
    }),
    postVehicleMileage: build.mutation<WriteVehicleMileageApiResponse, WriteVehicleMileageApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/mileage`,
        method: 'POST',
        body: queryArg.writeMileageRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [{type: 'Vehicle', id: queryArg.vehicleId}],
    }),
    correctVehicleMileage: build.mutation<
      CorrectVehicleMileageApiResponse,
      CorrectVehicleMileageApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/correct-mileage`,
        method: 'POST',
        body: queryArg.correctMileageRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [{type: 'Vehicle', id: queryArg.vehicleId}],
    }),
  }),
});

const {
  usePutVehicleToSaleMutation,
  useChangeVehicleTypeMutation,
  useGetSimilarVehiclesQuery,
  useLazyGetSimilarVehiclesQuery,
  useGetSimilarVehiclesV2Query,
  useLazyGetSimilarVehiclesV2Query,
  useSetFeatureAsNotHighlightedMutation,
  useLazyGetVehicleQuery,
  useGetVehicleQuery,
  useRotateVehiclePhotoMutation,
  useDeleteVehicleMutation,
  useSetFeatureAsHighlightedMutation,
  useLazyDownloadGalleryQuery,
  useGetVehicleInsightsQuery,
  useGetVehicleStatisticsQuery,
  usePartialUpdateVehicleMutation,
  useCreateVehicleMutation,
  useCreateVehicleToBuyMutation,
  useSetFeaturesHighlightedMutation,
  useUpdateVehicleMutation,
  useGetAdditionalNoteQuery,
  useLazyGetAdditionalNoteQuery,
  useSetAdditionalNoteMutation,
  useLazyGetAutofillFeaturesQuery,
  useLazyPutAutofillFeaturesQuery,
  useGetVehicleFinancialInstitutionQuery,
  useGetVehicleMileageValidationQuery,
  useLazyGetVehicleMileageValidationQuery,
  useUpdateVehicleFinancialInstitutionMutation,
  useListVehicleAlbumsQuery,
  useLazyListVehicleAlbumsQuery,
  useListTestDriveQuery,
  useCreateVehicleAlbumMutation,
  useBulkCreateHighlightsMutation,
  useDeleteHighlightMutation,
  useListHighlightsQuery,
  useBulkCreateShortcomingsMutation,
  useGetVehiclePhotosQuery,
  useLazyGetVehiclePhotosQuery,
  useDeleteShortcomingMutation,
  useListShortcomingsQuery,
  useGetVehicleV2Query: _useGetVehicleV2Query,
  useLazyGetVehicleV2Query: _useLazyGetVehicleV2Query,
  useCreateVehicleV2Mutation: _useCreateVehicleV2Mutation,
  useUpdateVehicleV2Mutation: _useUpdateVehicleV2Mutation,
  useAddFilesToVehicleAlbumMutation,
  useArchiveVehicleMutation,
  useUnarchiveVehicleMutation,
  useDeletePhotoMutation,
  useRemoveVehiclePhotosBackgroundMutation,
  useDeleteVehicleAlbumMutation,
  useCreateVehiclePriceReportMutation,
  useGetVehiclePriceReportsQuery,
  useCreateVehiclePriceReportPreviewQuery,
  usePutBackgroundRemovalSettingsMutation,
  useCreatePriceReportRequestMutation,
  useGetVehicleInsuranceQuery,
  useLazyGetVehicleInsuranceQuery,
  useSetVehicleInsuranceMutation,
  useGetAuditsQuery,
  useSetVehicleCustomIdMutation,
  useCopyAuditPhotoToAlbumMutation,
  useGetServiceVehicleHomeBranchQuery,
  usePutServiceVehicleHomeBranchMutation,
  useCreateBackgroundRemovalMutation,
  useGetBackgroundRemovalV2Query,
  useUpdateBackgroundRemovalV2Mutation,
  useDeleteBackgroundRemovalMutation,
  useCreateWatermarkMutation,
  useDeleteWatermarkMutation,
  useGetWatermarkDetailQuery,
  useGetBackgroundRemovalListQuery,
  useUpdateWatermarkDetailMutation,
  useGetVehicleCoverPhotoQuery,
  useGetVehicleAlbumPhotoListQuery,
  useLazyGetVehicleAlbumPhotoListQuery,
  useSetVehicleAlbumCoverPhotoMutation,
  useUnsetVehicleAlbumCoverPhotoMutation,
  useGetWatermarkListQuery,
  useLazyGetWatermarkListQuery,
  useGetServiceAlbumListQuery,
  useLazyGetServiceAlbumListQuery,
  useGetServiceAlbumPhotoListQuery,
  useLazyGetServiceAlbumPhotoListQuery,
  useDownloadServiceGalleryMutation,
  useAddFilesToServiceAlbumMutation,
  useDeleteServicePhotoMutation,
  useListHighlightsForTenantQuery,
  useListShortcomingsForTenantQuery,
  useCreateWatermarkV2Mutation,
  useUpdateWatermarkV2Mutation,
  useGetVehicleListQuery,
  useVehiclePhotoCopyMutation,
  useVehiclePhotoDeleteMutation,
  useVehiclePhotoUpdateAlbumMutation,
  useGetVehicleMileageQuery,
  useLazyGetVehicleMileageQuery,
  usePostVehicleMileageMutation,
  useCorrectVehicleMileageMutation,
  useCreateAutotracerPlReportMutation,
  useGetVehicleAutotracerPlReportsQuery,
  useGetAutotracerPlReportQuery,
  useGetAutotracerPlPreviewQuery,
} = vehicleApi;

/**
 * @deprecated Use `@dms/api/modules/vehicleOperations getVehicle` instead
 */
export const useGetVehicleV2Query = _useGetVehicleV2Query;

/**
 * @deprecated Use `@dms/api/modules/vehicleOperations getVehicle` instead
 */
export const useLazyGetVehicleV2Query = _useLazyGetVehicleV2Query;

/**
 * @deprecated Use `@dms/api/modules/vehicleOperations createVehicle` instead
 */
export const useCreateVehicleV2Mutation = _useCreateVehicleV2Mutation;

/**
 * @deprecated Use `@dms/api/modules/vehicleOperations updateVehicle` instead
 */
export const useUpdateVehicleV2Mutation = _useUpdateVehicleV2Mutation;

export {
  usePutVehicleToSaleMutation,
  useChangeVehicleTypeMutation,
  useGetSimilarVehiclesQuery,
  useLazyGetSimilarVehiclesQuery,
  useGetSimilarVehiclesV2Query,
  useLazyGetSimilarVehiclesV2Query,
  useSetFeatureAsNotHighlightedMutation,
  useLazyGetVehicleQuery,
  useGetVehicleQuery,
  useRotateVehiclePhotoMutation,
  useDeleteVehicleMutation,
  useSetFeatureAsHighlightedMutation,
  useLazyDownloadGalleryQuery,
  useGetVehicleInsightsQuery,
  useGetVehicleStatisticsQuery,
  usePartialUpdateVehicleMutation,
  useCreateVehicleMutation,
  useCreateVehicleToBuyMutation,
  useSetFeaturesHighlightedMutation,
  useUpdateVehicleMutation,
  useGetAdditionalNoteQuery,
  useLazyGetAdditionalNoteQuery,
  useSetAdditionalNoteMutation,
  useLazyGetAutofillFeaturesQuery,
  useLazyPutAutofillFeaturesQuery,
  useGetVehicleFinancialInstitutionQuery,
  useUpdateVehicleFinancialInstitutionMutation,
  useListVehicleAlbumsQuery,
  useLazyListVehicleAlbumsQuery,
  useListTestDriveQuery,
  useCreateVehicleAlbumMutation,
  useBulkCreateHighlightsMutation,
  useDeleteHighlightMutation,
  useListHighlightsQuery,
  useBulkCreateShortcomingsMutation,
  useGetVehiclePhotosQuery,
  useLazyGetVehiclePhotosQuery,
  useDeleteShortcomingMutation,
  useListShortcomingsQuery,
  useAddFilesToVehicleAlbumMutation,
  useArchiveVehicleMutation,
  useUnarchiveVehicleMutation,
  useDeletePhotoMutation,
  useRemoveVehiclePhotosBackgroundMutation,
  useDeleteVehicleAlbumMutation,
  useCreateVehiclePriceReportMutation,
  useGetVehiclePriceReportsQuery,
  useCreateVehiclePriceReportPreviewQuery,
  usePutBackgroundRemovalSettingsMutation,
  useCreatePriceReportRequestMutation,
  useGetVehicleInsuranceQuery,
  useLazyGetVehicleInsuranceQuery,
  useSetVehicleInsuranceMutation,
  useGetAuditsQuery,
  useSetVehicleCustomIdMutation,
  useCopyAuditPhotoToAlbumMutation,
  useGetServiceVehicleHomeBranchQuery,
  usePutServiceVehicleHomeBranchMutation,
  useCreateBackgroundRemovalMutation,
  useGetBackgroundRemovalV2Query,
  useUpdateBackgroundRemovalV2Mutation,
  useDeleteBackgroundRemovalMutation,
  useCreateWatermarkMutation,
  useDeleteWatermarkMutation,
  useGetWatermarkDetailQuery,
  useGetBackgroundRemovalListQuery,
  useUpdateWatermarkDetailMutation,
  useGetVehicleCoverPhotoQuery,
  useGetVehicleAlbumPhotoListQuery,
  useLazyGetVehicleAlbumPhotoListQuery,
  useSetVehicleAlbumCoverPhotoMutation,
  useUnsetVehicleAlbumCoverPhotoMutation,
  useGetWatermarkListQuery,
  useLazyGetWatermarkListQuery,
  useGetVehicleListQuery,
  useGetServiceAlbumListQuery,
  useLazyGetServiceAlbumListQuery,
  useGetServiceAlbumPhotoListQuery,
  useLazyGetServiceAlbumPhotoListQuery,
  useDownloadServiceGalleryMutation,
  useAddFilesToServiceAlbumMutation,
  useDeleteServicePhotoMutation,
  useListHighlightsForTenantQuery,
  useListShortcomingsForTenantQuery,
  useCreateWatermarkV2Mutation,
  useUpdateWatermarkV2Mutation,
  useVehiclePhotoCopyMutation,
  useVehiclePhotoDeleteMutation,
  useVehiclePhotoUpdateAlbumMutation,
  useGetVehicleMileageValidationQuery,
  useLazyGetVehicleMileageValidationQuery,
  useGetVehicleMileageQuery,
  useLazyGetVehicleMileageQuery,
  usePostVehicleMileageMutation,
  useCorrectVehicleMileageMutation,
  useCreateAutotracerPlReportMutation,
  useGetVehicleAutotracerPlReportsQuery,
  useGetAutotracerPlReportQuery,
  useGetAutotracerPlPreviewQuery,
};
